// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountOptionalServiceModel {
    static getAttributeTypeMap() {
        return AccountOptionalServiceModel.attributeTypeMap;
    }
}
AccountOptionalServiceModel.discriminator = undefined;
AccountOptionalServiceModel.additionalProperties = false;
AccountOptionalServiceModel.attributeTypeMap = [
    {
        "name": "optionalServiceId",
        "baseName": "optionalServiceId",
        "type": "number"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "lastOptInStateChangeDate",
        "baseName": "lastOptInStateChangeDate",
        "type": "Date"
    },
];
//# sourceMappingURL=accountOptionalServiceModel.js.map